module.exports = __webpack_public_path__ + "static/media/08_1440.ba614407.jpeg";